import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppLoaderService } from '../../services/app-loader.service';

@Component({
  selector: 'app-loader-overlay',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div *ngIf="state?.visible" class="app-loader-overlay">
      <div class="loader-card">
        <i class="pi pi-spin pi-spinner text-3xl text-blue-600"></i>
        <div class="msg">{{ state?.message || 'Loading…' }}</div>
      </div>
    </div>
  `,
  styles: [`
    /* Must sit above topbar/menus so navigation can't be "double-clicked" */
    .app-loader-overlay { position: fixed; inset: 0; background: rgba(255,255,255,0.65); backdrop-filter: blur(2px); display: flex; align-items: center; justify-content: center; z-index: 2147483647; cursor: wait; }
    .loader-card { background: #ffffff; padding: 16px 20px; border-radius: 10px; box-shadow: 0 10px 25px rgba(0,0,0,0.12); display: flex; align-items: center; gap: 10px; }
    .msg { font-size: 14px; color: #334155; font-weight: 500; }
  `]
})
export class AppLoaderOverlayComponent {
  state: { visible: boolean; message?: string } | null = null;
  constructor(loader: AppLoaderService) {
    loader.overlayState$.subscribe(s => this.state = s);
  }
}


